import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "bg-green-dark py-16" }
const _hoisted_2 = { class: "container mx-auto text-white gap-16 grid" }
const _hoisted_3 = ["innerHTML"]


export default /*#__PURE__*/_defineComponent({
  props: {
    article: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "text-white",
        innerHTML: __props.article
      }, null, 8, _hoisted_3)
    ])
  ]))
}
}

})